import { api } from "../api";
import { clearAuthToken, getAuthToken, setAuthToken } from "../utils/authToken";

const buildAuthPath = (path) => {
  const base = api?.defaults?.baseURL || "";
  const normalizedBase = String(base).replace(/\/+$/, "");
  const hasApiPrefix = /\/api\/v1$/.test(normalizedBase);
  const prefix = hasApiPrefix ? "" : "/api/v1";
  return `${prefix}${path}`;
};

export const AuthService = {
  async login(email, password) {
    const payload = {
      email,
      password,
      device_name: "web",
    };
    const { data } = await api.post(buildAuthPath("/auth/login"), payload);
    const token = data?.data?.token;
    if (token) {
      setAuthToken(token);
    }
    return {
      ok: data?.status === "success",
      status: data?.status,
      message: data?.message,
      token,
      user: data?.data?.user || null,
      abilities: data?.data?.abilities || [],
    };
  },

  async logout() {
    try {
      await api.post(buildAuthPath("/auth/logout"));
    } finally {
      clearAuthToken();
    }
    return { ok: true };
  },

  async me() {
    if (!getAuthToken()) {
      return { authenticated: false, user: null };
    }

    try {
      const { data } = await api.get(buildAuthPath("/auth/me"));
      return {
        authenticated: true,
        user: data?.data?.user || null,
      };
    } catch (error) {
      if (error?.response?.status === 401) {
        clearAuthToken();
        return { authenticated: false, user: null };
      }
      throw error;
    }
  },

  async checkEmailExists(email) {
    const { data } = await api.post(buildAuthPath("/auth/check-email"), {
      email,
    });
    return data?.data?.exists === true;
  },
};
